import React from 'react';

import UserList from './userlist';
import UserForm from './userform';

import AppActions from '../../actions/app-actions';
import AppStore from '../../stores/app-store';

// material ui
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

import { preformatWithRequestID, getUserRoleFromJWT } from '../../helpers';

import { logout } from '../../auth';

export default class UserManagement extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this._getState();
  }

  UNSAFE_componentWillMount() {
    AppStore.changeListener(this._onChange.bind(this));
  }

  componentDidMount() {
    this._getData();
  }

  _getState() {
    return {
      editPass: false,
      currentUser: AppStore.getCurrentUser(),
      currentUserRole: getUserRoleFromJWT(),
      tenant: null
    };
  }
  _onChange() {
    this.setState({currentUser: AppStore.getCurrentUser(), currentUserRole: getUserRoleFromJWT() });
  }
  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this._getData();
    }
  }
  componentWillUnmount() {
    AppStore.removeChangeListener(this._onChange.bind(this));
  }

  _getData() {
    Promise.all([AppActions.getUserList(), this._getTenantDetails()])
      .then(results => {
        this.setState({users: results[0], tenant: results[1]});
      })
      .catch(err => {
        var errormsg = err.error || 'Please check your connection';
        AppActions.setSnackbar(preformatWithRequestID(err.res, `Users couldn't be loaded. ${errormsg}`));
      });
  }

  _getUserList() {
    var self = this;
    return AppActions.getUserList()
      .then(users => self.setState({ users: users }))
      .catch(err => {
        var errormsg = err.error || 'Please check your connection';
        AppActions.setSnackbar(preformatWithRequestID(err.res, `Users couldn't be loaded. ${errormsg}`));
      });
  }

  _getTenantDetails() {
    if (AppStore.hasMultitenancy() && this.state.currentUserRole === 'admin') {
      return AppActions.getUserOrganization();
    } else {
      return Promise.resolve(null);
    }
  }

  _openCreate() {
    this._openEdit();
  }
  _openEdit(user) {
    AppActions.setSnackbar('');
    this.setState({ user: user, editDialog: true, removeDialog: false, editPass: !user });
  }

  _openRemove(user) {
    AppActions.setSnackbar('');
    this.setState({ user: user, editDialog: false, removeDialog: true });
  }

  dialogDismiss() {
    this.setState({ editDialog: false, removeDialog: false });
  }
  _editSubmit(userData) {
    var self = this;
    const role = this.state.currentUserRole === 'systemadm' ? 'systemadm' : userData.role;
    return AppActions.editUser(self.state.user.id, {...userData, role})
      .then(() => {
        self.dialogDismiss();
        AppActions.setSnackbar('The user has been updated.');
        self._getUserList();
        // if current logged in user
        if (self.state.user.id === self.state.currentUser.id) {
          AppActions.setCurrentUser(userData);
          logout();
        }
      })
      .catch(err => {
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(preformatWithRequestID(err.res, `There was an error editing the user. ${errMsg}`));
      });
  }

  _createSubmit(userData) {
    var self = this;
    const role = this.state.currentUserRole === 'systemadm' ? 'systemadm' : userData.role;
    return AppActions.createUser({...userData, role})
      .then(() => {
        self.dialogDismiss();
        AppActions.setSnackbar('The user was created successfully.');
        self._getUserList();
      })
      .catch(err => {
        console.log(err);
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(preformatWithRequestID(err.res, `There was an error creating the user. ${errMsg}`));
      });
  }

  _removeSubmit() {
    var self = this;
    return AppActions.removeUser(this.state.user.id)
      .then(() => {
        self.dialogDismiss();
        AppActions.setSnackbar('The user was removed from the system.');
        self._getUserList();
      })
      .catch(err => {
        console.log(err);
        var errMsg = err.res.body.error || '';
        AppActions.setSnackbar(preformatWithRequestID(err.res, `There was an error removing the user. ${errMsg}`));
      });
  }

  _togglePass() {
    this.setState({ editPass: !this.state.editPass });
  }

  _emailSuffix() {
    return this.state.currentUserRole === 'admin' && this.state.tenant ? `@${this.state.tenant.name}.com` : '@ewm.com';
  }

  render() {
    const {user=null} = this.state;
    const email = (user && user.email);
    var removeActions = [
      <div key="remove-button-1" style={{ marginRight: '10px', display: 'inline-block' }}>
        <Button onClick={() => this.dialogDismiss()}>Cancel</Button>
      </div>,
      <Button variant="contained" key="remove-button-2" color="primary" onClick={() => this._removeSubmit()}>
        Remove user
      </Button>
    ];
    return (
      <div>
        <div className="float-right">
          <Button variant="contained" color="primary" disabled={this.state.currentUserRole === 'viewer'} onClick={() => this._openCreate()}>
            Create new user
          </Button>
        </div>

        <UserList
          users={this.state.users || []}
          editUser={user => this._openEdit(user)}
          removeUser={user => this._openRemove(user)}
          currentUser={this.state.currentUser}
        />
        {
          this.state.editDialog
            ? <UserForm open={true} type={user ? 'edit' : 'create'}
              email={email}
              role={(user && user.role) || ''}
              showRole={this.state.currentUserRole !== 'systemadm'}
              currentUser={user && (user.id === this.state.currentUser.id)}
              handleOk={data => {
                if (user) {
                  this._editSubmit(data);
                } else {
                  this._createSubmit(data)
                }
              }}
              handleCancel={() => this.dialogDismiss()} />
            : null
        }

        <Dialog open={this.state.removeDialog || false}>
          <DialogTitle>Remove user?</DialogTitle>
          <DialogContent style={{ overflow: 'hidden' }}>
            Are you sure you want to remove the user with email{' '}
            <b>
              <i>{(this.state.user || {}).email}</i>
            </b>
            ?
          </DialogContent>
          <DialogActions>{removeActions}</DialogActions>
        </Dialog>
      </div>
    );
  }
}
